import { faRectangleAd } from '@fortawesome/pro-light-svg-icons';
import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@sixui/ui';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import { Heading } from '~/components/molecules/Heading';
import { AdList } from '../organisms/AdList';
import { AppBreadcrumbs } from '../organisms/Breadcrumbs';

export type IAppAdsPageProps = {
  appId: string;
};

export const AppAdsPage: React.FC<IAppAdsPageProps> = (props) => {
  const { appId } = props;
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t('AppAdsPage.seo.title')}</title>
      </Helmet>

      <AppBreadcrumbs appId={appId} />

      <Heading
        icon={<FontAwesomeIcon icon={faRectangleAd} />}
        title={t('AppAdsPage.title')}
        subtitle={t('AppAdsPage.subtitle')}
        actions={
          <Button
            href={`/apps/${appId}/ads/create`}
            icon={<FontAwesomeIcon icon={faPlus} />}
          >
            {t('AppAdsPage.create')}
          </Button>
        }
      />

      <AdList appId={appId} />
    </>
  );
};
